export default "__VITE_ASSET__D7FG98En__"